import React, { useState } from 'react';
import styled from 'styled-components';
import { QRCodeSVG } from 'qrcode.react';
import { FaCopy, FaCheck, FaExternalLinkAlt } from 'react-icons/fa';
import { colors } from '../../../../assets/styles/GlobalStyles';

const Wrapper = styled.div`
  background: #f8fafc;
  border: 1px solid ${colors.borderLight};
  border-radius: 10px;
  padding: 1rem 1.1rem;
  text-align: left;

  & + & {
    margin-top: 0.75rem;
  }
`;

const Label = styled.span`
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${colors.textMuted};
  margin-bottom: 0.5rem;
`;

const Linha = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: white;
  border: 1px solid ${colors.borderLight};
  border-radius: 8px;
  padding: 0.55rem 0.8rem;
`;

const Codigo = styled.code`
  flex: 1;
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', monospace;
  font-size: 0.8rem;
  line-height: 1.4;
  color: ${colors.darkGray};
  word-break: break-all;
`;

const BotaoCopiar = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${(props) => (props.$copiado ? '#16a34a' : colors.lightBlue)};
  padding: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
  flex-shrink: 0;
  border-radius: 6px;

  &:hover {
    background: #f1f5f9;
  }
`;

const LinkExterno = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.65rem;
  color: ${colors.lightBlue};
  font-size: 0.85rem;
  font-weight: 500;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const QrWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 1rem;
  background: white;
  border: 1px solid ${colors.borderLight};
  border-radius: 8px;
  margin-bottom: 0.75rem;
`;

/**
 * Bloco de código copiável (linha digitável do boleto, PIX copia-e-cola, etc.)
 * com botão de copiar e, opcionalmente, um QR Code (pra PIX) e/ou um link
 * externo (ex: PDF do boleto).
 */
const CodigoCopiavel = ({ label, valor, linkHref, linkLabel, qrCode }) => {
  const [copiado, setCopiado] = useState(false);

  if (!valor) return null;

  const handleCopiar = () => {
    navigator.clipboard?.writeText(valor);
    setCopiado(true);
    setTimeout(() => setCopiado(false), 2000);
  };

  return (
    <Wrapper>
      <Label>{label}</Label>

      {qrCode && (
        <QrWrapper>
          <QRCodeSVG value={valor} size={180} marginSize={0} />
        </QrWrapper>
      )}

      <Linha>
        <Codigo>{valor}</Codigo>
        <BotaoCopiar type="button" onClick={handleCopiar} $copiado={copiado} title={`Copiar ${label}`}>
          {copiado ? <FaCheck /> : <FaCopy />}
        </BotaoCopiar>
      </Linha>
      {linkHref && (
        <LinkExterno href={linkHref} target="_blank" rel="noopener noreferrer">
          {linkLabel} <FaExternalLinkAlt size={12} />
        </LinkExterno>
      )}
    </Wrapper>
  );
};

export default CodigoCopiavel;
